// Instance
import MainAPI from '@/app/apis/main/main-api.js';

// Endpoints
import { API, ENDPOINTS, ENDPOINTS_GET } from '@/app/apis/main/_connection/connection-api.js';

// Query String
const queryString = require('querystring');

class subscriptionAPI extends MainAPI {
  /**
   * @return {object} subscription period list
   */
  async getSubscriptionPeriodList() {
    return API.get(ENDPOINTS.GET_SUBSCRIPTION_PERIOD);
  }

  /**
   * @param queryParams
   * @return {object} Subscription List
   * */
  async getSubscriptionList(queryParams) {
    return API.get(`${ENDPOINTS.GET_SUBSCRIPTION_LIST}?${queryString.stringify(queryParams)}`);
  }

  /**
   * @param subscriptionId
   * */
  async getSubscriptionDetailsById(subscriptionId) {
    return API.get(`${ENDPOINTS.GET_SUBSCRIPTION}/admin/${subscriptionId}`);
  }

	/**
	 * Cancel a subscription by its ID along with remarks.
	 * 
	 * @param {number} subscriptionId - The ID of the subscription to cancel.
	 * @param {Object} updateDetails - Object containing update details.
	 * @param {string} updateDetails.status - The new status of the subscription.
	 * @param {string} [updateDetails.remarks] - Remarks or reason for the cancellation update (optional).
	 * @returns {Promise<void>} - A Promise that resolves when the update is successful.
	 * @throws {Error} - Throws an error if the update fails.
	*/
  async cancelSubscription(subscriptionId, updateDetails) {
    return API.put(`${ENDPOINTS.PUT_SUBSCRIPTION}/${subscriptionId}/cancel`, updateDetails);
  }

  /**
   * @param subscriptionId
   * */
  async deleteSubscription(subscriptionId) {
    return API.delete(`${ENDPOINTS.DELETE_SUBSCRIPTION}/${subscriptionId}/delete`);
  }

	/**
	 * Update the status of a subscription by its ID along with remarks.
	 * 
	 * @param {number} subscriptionId - The ID of the subscription to update.
	 * @param {Object} updateDetails - Object containing update details.
	 * @param {string} updateDetails.status - The new status of the subscription.
	 * @param {string} [updateDetails.remarks] - Remarks or reason for the status update (optional).
	 * @returns {Promise<void>} - A Promise that resolves when the update is successful.
	 * @throws {Error} - Throws an error if the update fails.
	*/
	async updateSubscriptionStatusById(subscriptionId, updateDetails) {
    return API.put(`${ENDPOINTS.PUT_SUBSCRIPTION}/${subscriptionId}`, updateDetails);
	}
}

export default new subscriptionAPI();
